// extracted by mini-css-extract-plugin
module.exports = {"member__img":"rosterCard_member__img__3uwKg"};